module.exports = __webpack_public_path__ + "img/ESpearman64_ua.a3f4bd71.webp";